<template>
  <div>
    <v-container grid-list-md fluid>
      <v-layout align-center justify-center row fill-height v-if="!sinSelector">
        <v-flex xs12 sm6 md4 d-flex>
          <v-select
            :items="data.rs"
            item-text="texto"
            item-value="tickets"
            label="Seleccione la cantidad de días"
            solo
            small
            @change="buscarTickets"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-space-around row fill-height>
        <v-flex xs12 sm3 v-for="(t, tinx) in flexFiltrados" :key="tinx">
          <PanelPase :pase="{ pase: t, comparador: data.comparador }"> </PanelPase>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
//import PanelPase from "@/components/pases/PanelPase.vue";
import Loading from "@/components/utiles/Loading.vue"
const PanelPase = () => ({
  // The component to load (should be a Promise)
  component: import("@/components/pases/PanelPase.vue"),
  // A component to use while the async component is loading
  loading: Loading,
  // A component to use if the load fails
  // error: ErrorComponent,
  // Delay before showing the loading component. Default: 200ms.
  delay: 1,
  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000
})
export default {
  name: "listadoTicketsFlexibles",
  props: ["data"],
  components: {
    PanelPase,
    Loading
  },
  created() {
    this.preparar()
  },
  mounted() {},
  beforeCreate() {},
  methods: {
    preparar() {
      this.sinSelector = this.data.rs.length === 1 ? true : false
      if (this.sinSelector) {
        this.flexFiltrados = this.data.rs[0].tickets
      }
    },
    buscarTickets(tickets) {
      this.flexFiltrados = tickets
    }
  },
  data() {
    return {
      sinSelector: false,
      flexFiltrados: [],
      flexibles: []
    }
  },
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios"
    })
  }
}
</script>
